export enum TimesheetDateEditLevelEnum {
  All = 1,
  None = 2,
  OnlyOthers = 3
}
